import _slicedToArray from "@babel/runtime-corejs3/helpers/slicedToArray";import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";import _mapInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/map";import React, { useEffect, useState } from 'react';
import clsx from 'clsx';
import Button from "../../Button";

import { PRODUCT_LINES_CONTENT_MAP, ProductLineSectionType } from "../../../utils/ProductLinesHelper";
import ChevronDown from "../../../icons/ChevronDown";
import ChevronUp from "../../../icons/ChevronUp";
import ShieldHeart from "../../../icons/ShieldHeart";
import { createStyles } from "./styles";

















var ProductLineSwitcher = function ProductLineSwitcher(_ref)



{var _PRODUCT_LINES_CONTEN, _context, _context2;var onChange = _ref.onChange,productLineIds = _ref.productLineIds,activeProductLineId = _ref.activeProductLineId;
  var _useState = useState(
    activeProductLineId || productLineIds[0]),_useState2 = _slicedToArray(_useState, 2),activeButton = _useState2[0],setActiveButton = _useState2[1];

  var _useState3 = useState(false),_useState4 = _slicedToArray(_useState3, 2),showAncillaryButtons = _useState4[0],setShowAncillaryButtons = _useState4[1];

  var isActiveButtonAncillary =
  ((_PRODUCT_LINES_CONTEN = PRODUCT_LINES_CONTENT_MAP[activeButton]) === null || _PRODUCT_LINES_CONTEN === void 0 ? void 0 : _PRODUCT_LINES_CONTEN.section) === ProductLineSectionType.ANCILLARY || false;

  var classes = createStyles();

  var onProductLineChange = function onProductLineChange(productLine) {
    onChange(productLine);
    setActiveButton(productLine);
  };

  useEffect(function () {
    if (activeProductLineId) {
      setActiveButton(activeProductLineId);
    }
    setShowAncillaryButtons(isActiveButtonAncillary);
  }, [activeProductLineId]);

  useEffect(function () {
    setShowAncillaryButtons(isActiveButtonAncillary);
  }, [activeButton, activeProductLineId]);

  var filterPLineByType = function filterPLineByType(type) {
    return _filterInstanceProperty(productLineIds).call(productLineIds,
    function (productLine) {var _PRODUCT_LINES_CONTEN2;return ((_PRODUCT_LINES_CONTEN2 = PRODUCT_LINES_CONTENT_MAP[productLine]) === null || _PRODUCT_LINES_CONTEN2 === void 0 ? void 0 : _PRODUCT_LINES_CONTEN2.section) === type;});

  };

  var GeneralProductLineButtons = _mapInstanceProperty(_context = filterPLineByType(ProductLineSectionType.GENERAL)).call(_context,
  function (pLineId) {
    return /*#__PURE__*/(
      React.createElement(Button, {
        key: pLineId,
        type: "outlined",
        color: activeButton === pLineId ? 'primary' : 'default',
        leftIconProp: PRODUCT_LINES_CONTENT_MAP[pLineId].icon('2.4rem'),
        onClick: function onClick() {
          onProductLineChange(pLineId);
          setShowAncillaryButtons(false);
        },
        className: clsx(
        classes.button,
        activeButton === pLineId ? classes.activeButton : classes.inactiveButton),

        size: "large" },

      PRODUCT_LINES_CONTENT_MAP[pLineId].label));


  });


  var AncillaryProductLineButtons = _mapInstanceProperty(_context2 = filterPLineByType(ProductLineSectionType.ANCILLARY)).call(_context2,
  function (pLineId) {return /*#__PURE__*/(
      React.createElement(Button, {
        key: pLineId,
        type: "text",
        color: activeButton === pLineId ? 'primary' : 'default',
        onClick: function onClick() {
          onProductLineChange(pLineId);
        },
        className: clsx(
        classes.ancillaryButton,
        activeButton === pLineId ? classes.activeAncillaryButton : classes.inactiveButton),

        size: "small" },

      PRODUCT_LINES_CONTENT_MAP[pLineId].label));});




  var AncillaryProductLinesBlock = /*#__PURE__*/
  React.createElement("div", null, /*#__PURE__*/
  React.createElement(Button, {
    type: "outlined",
    color: "default",
    leftIconProp: /*#__PURE__*/React.createElement(ShieldHeart, null),
    rightIconProp: showAncillaryButtons ? /*#__PURE__*/React.createElement(ChevronUp, null) : /*#__PURE__*/React.createElement(ChevronDown, null),
    onClick: function onClick() {
      setShowAncillaryButtons(!showAncillaryButtons);
    },
    className: clsx(
    classes.button,
    isActiveButtonAncillary ? classes.ancillaryDropdown : classes.inactiveButton),

    size: "large" }, "Ancillary"),



  showAncillaryButtons && AncillaryProductLineButtons);



  return /*#__PURE__*/(
    React.createElement("div", { className: classes.productLinesSection }, /*#__PURE__*/
    React.createElement("p", { className: classes.promt }, "Choose Product line to see products"), /*#__PURE__*/
    React.createElement("div", { className: classes.buttonsSection },
    GeneralProductLineButtons,
    AncillaryProductLineButtons.length > 0 && AncillaryProductLinesBlock)));



};

export default ProductLineSwitcher;
//# sourceMappingURL=index.js.map